import { useState, useEffect, useMemo } from 'react'

const useDelayUnmount = (initialState, delayTime) => {
  const [state, setState] = useState(initialState)
  const [delayState, setDelayState] = useState(initialState)

  useEffect(() => {
    let timeoutId
    if (state && !delayState) {
      setDelayState(true)
    } else if (!state && delayState) {
      timeoutId = setTimeout(() => setDelayState(false), delayTime)
    }
    return () => clearTimeout(timeoutId)
  }, [delayTime, delayState, state])

  return useMemo(() => ({ state, delayState, setState }), [delayState, state])
}

export default useDelayUnmount
